import { useOutletContext } from 'react-router-dom';
import type { Selection } from '@/lib/sponsor/selection';

export { defaultSelection } from '@/lib/sponsor/selection';
export type { Selection } from '@/lib/sponsor/selection';

export interface SponsorContext {
  selection: Selection;
  setSelection: (fn: (s: Selection) => Selection) => void;
}

export const useSponsorContext = () => useOutletContext<SponsorContext>();
